module.exports = __webpack_public_path__ + "static/media/th-room--vault.e2eae8f2.svg";